/** @format */

import {styled} from '@mui/material/styles';
import {Typography} from '@mui/material';

// Выравнивание по правому краю — как в FormattedCell (см. FormattedCell/styles.ts:Text).
export const NumericText = styled(Typography)(() => ({
  textAlign: 'right',
}));
